export const scheduleData = [
    {
        id: 1,
        time: '10:00 AM - 10:30 AM',
        title: 'Inauguration',
        description: 'The Chief Guest, Anas Rahman Junaid will be inaugurating the event. The inauguration will include an inaugural speech from Chairperson Excel, the Event Head and guest speakers.'
    },
    {
        id: 2,
        time: '10:30 AM - 11:15 AM',
        title: 'First Speaker Session',
        description: 'Anas Junaid Rahman, Founder and MD, Hurun India'
    },
    {
        id: 3,
        time: '11:20 AM - 12:05 PM',
        title: 'Second Speaker Session',
        description: 'Mukesh Bubna, Founder & CEO, Monexo'
    },
    {
        id: 4,
        time: '12:10 PM - 12:55 PM',
        title: 'Third Speaker Session',
        description: 'Kenz Milliondots - Founder, Milliondots Edu'
    },
    {
        id: 5,
        time: '1:00 PM - 1:45 PM',
        title: 'Lunch Break',
        description: ''
    },
    {
        id: 6,
        time: '1:45 PM - 2:30 PM',
        title: 'Fourth Speaker Session',
        description: 'Lijil Lakshman, CA, Co-Founder and Managing Partner of LDS & Co. '
    },
    {
        id: 7,
        time: '2:40 PM - 4:10 PM',
        title: 'Panel Discussion on the topic Cashless Society and Privacy',
        description: 'The panel discussion will consist of the panelists sharing facts or personal experiences, expressing opinions, and answering questions from the audience.'
    },
    {
        id: 8,
        time: '4:10 PM - 4:30 PM',
        title: 'Flash Talks',
        description: ''
    },
    {
        id: 9,
        time: '4:30 PM - 5:00 PM',
        title: 'Vote of Thanks and Snacks',
        description: 'Vote of thanks from the Chairperson and Organizers'
    },
]